<template>
  <v-container fluid>
    <v-row dense>
      <v-col>
        <tabella-distinta :documento="item" :trigger="trigger"/>
      </v-col>      
      <v-col>
        <grafico-distinta :documento="item" :trigger="trigger"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GraficoDistinta from './dettaglioDistinta/graficoDistinta'
  import TabellaDistinta from './dettaglioDistinta/tabellaDistinta'

  export default {
    components: {
      GraficoDistinta,
      TabellaDistinta
    },
    props: {
      item: Object,
      trigger: Number
    },
    data () {
      return {}
    },
    mounted() {
      console.log(this.item)
    }
  }
</script>
